import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Thunk to fetch IP address
export const fetchIpAddress = createAsyncThunk(
  "location/fetchIpAddress",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      if (!response.ok) {
        throw new Error("Failed to fetch IP address");
      }
      const data = await response.json();
      return data.ip;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk to fetch geolocation using browser API
export const fetchLocation = createAsyncThunk(
  "location/fetchLocation",
  async (_, { rejectWithValue }) => {
    if (!("geolocation" in navigator)) {
      return rejectWithValue("Geolocation not supported");
    }

    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          }),
        (err) => reject(rejectWithValue(err.message))
      );
    });
  }
);

const locationSlice = createSlice({
  name: "location",
  initialState: {
    locationOfUser: null,
    ipAddress: null,
    permission: localStorage.getItem("locationPermission") || "unknown",
    locationError: null,   
    ipError: null,         
    loadingLocation: false,
    loadingIp: false,      
  },
  reducers: {
    setPermission(state, action) {
      state.permission = action.payload;
      localStorage.setItem("locationPermission", action.payload);
    },
    clearPermission(state) {
      state.permission = "unknown";
      state.locationOfUser = null;
      state.ipAddress = null;
      state.locationError = null;
      state.ipError = null;
      localStorage.removeItem("locationPermission");
    },
  },
  extraReducers: (builder) => {
    builder
      // Location
      .addCase(fetchLocation.pending, (state) => {
        state.loadingLocation = true;
        state.locationError = null;
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.loadingLocation = false;
        state.locationOfUser = action.payload;
      })
      .addCase(fetchLocation.rejected, (state, action) => {
        state.loadingLocation = false;
        state.locationError = action.payload || "Location fetch failed";
      })

      // IP Address
      .addCase(fetchIpAddress.pending, (state) => {
        state.loadingIp = true;
        state.ipError = null;
      })
      .addCase(fetchIpAddress.fulfilled, (state, action) => {
        state.loadingIp = false;
        state.ipAddress = action.payload;
      })
      .addCase(fetchIpAddress.rejected, (state, action) => {
        state.loadingIp = false;
        state.ipError = action.payload || "IP fetch failed";
      });
  },
});

export const { setPermission, clearPermission } = locationSlice.actions;
export default locationSlice.reducer;

